<template>
    <div>
        <navbar1></navbar1>
        <div class="__buildbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-9 col-sm-12">

                        <p class="__welf1">Ready to build your app now?</p>
                        <p class="__welf2">Please fill the form below and we will reach out shortly.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="__form-wrap ">
                <form @submit.prevent="processForm()" action="/" method="POST" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-lg-5 col-md-4 col-sm-4">

                            <p class="__hirep">Also, if you want to form or<br> grow your devs team, <br>we're still your go-to brand</p>
                            <!-- <p class="__hirep1">We understand how critical talent is to the <br />success of any organization. Therefore, we</p> -->
                            <router-link to="/talent" class="btn __adjustlink">Hire Talents</router-link>
                            <!-- <div class="__selcard">
                                <div class="form-group">
                                    <label for="work-time">Select more than one</label>

                                        <div class="__radio-wrap">
                                        <div>
                                            <label class="check">
                                                UX & product designer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Front end developer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Back end developer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Project manager
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Data scientist
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                VR/AR developers
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="projb">Project budget</label>

                                    <input
                                    autofocus
                                    type="text"
                                    class="form-control __form-control"
                                    id="projb"
                                    name="projb"
                                    data-field="general"
                                    placeholder="N 000,000.00"
                                    />
                                </div>
                                
                            </div> -->
                        </div>
                        <div class="col-lg-7 col-md-8 col-sm-8">
                            <p class="__hirep">Let us know you</p>

                            <!-- <p class="__hirep1">We understand how critical talent is to the <br />
                            success of any organization. Therefore, we</p> -->
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="full-name">Full name</label>
                                        <input type="text" v-model="formField.fullname" name="fullname" placeholder="John Jane Doe " class="form-control __form-control" required>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>

                                        <input
                                        type="email"
                                        class="form-control __form-control"
                                        id="email"
                                        name="email"
                                        v-model="formField.email"
                                        data-field="email"
                                        placeholder="address@yourdomain.com"
                                        required="required"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="phone">Phone number</label>
                                        <input
                                        type="tel"
                                        class="form-control __form-control"
                                        id="phone"
                                        name="phone"
                                        v-model="formField.phone"
                                        data-field="phone"
                                        placeholder="+234 812 345 6789"
                                        required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="work-dur">Company</label>

                                        <input
                                        type="text"
                                        class="form-control __form-control"
                                        id="work-dur"
                                        name="company"
                                        v-model="formField.company"
                                        data-field="general"
                                        placeholder="Enter company name"
                                        required="required"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="file">Brief file</label>
                                        <input type="file" ref="file" id="file" v-on:change="uploadFile()" placeholder=" " class="form-control __form-control" required>
                                        
                                        
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="skypeId">Contact link or Skype ID</label>

                                        <input
                                        type="text"
                                        class="form-control __form-control"
                                        id="skypeId"
                                        name="skypeId"
                                        v-model="formField.skypeId"
                                        data-field="general"
                                        placeholder="Enter link or ID here"
                                        required="required"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="links">Links (Similar Project)</label>

                                <input
                                type="text"
                                class="form-control __form-control"
                                id="links"
                                name="links"
                                v-model="formField.links"
                                data-field="general"
                                placeholder="Links (similar project)"
                                required="required"
                                />
                            </div>
                            <div class="form-group">
                                <label for="project-desc">Project description</label>

                                <textarea
                                class="form-control"
                                id="project-desc"
                                name="brief"
                                rows="5"
                                v-model="formField.brief"
                                data-field="general"
                                placeholder="Type here"
                                required="required"
                                ></textarea>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                <button type="submit" class="btn btn-block  __adjustlink ">Submit form</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Magic in 4 steps</p>
                <p class="__wedop1">We have a four-step development process: We Listen, We Execute, We Deploy<br> and You Smile.</p>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/communication.png" class="__hidimg">
                        <p class="__hidep">We listen</p>
                        <p class="__hidep1">Talk to us about what<br> you want</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/management.png" class="__hidimg">
                        <p class="__hidep">We execute</p>
                        <p class="__hidep1">We research, form a<br> team and get to work.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/checklist.png" class="__hidimg">
                        <p class="__hidep">We deploy</p>
                        <p class="__hidep1">You test, give feedback<br> and approve.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/smile.png" class="__hidimg">
                        <p class="__hidep">You smile</p>
                        <p class="__hidep1">You are happy, because<br> the project is completed</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__midbg1">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-9">
                        <p class="__ourp">Want to partner<br> with us?</p>
                        <p class="__ourp1">There are many ways we can work together,<br> There are other projects at Findworka. We<br> have the Saucecode community of talents, Findworka Fellowship for aspiring software engineers, Findworka Mentors for experienced software instructors and the annual Saucecode Hackathons</p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <router-link to="/academy"><div class="__impcard">
                                    <div class="__impimg __acadimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Findworka academy</p>
                                        <p class="__impp1">A fellowship programme for aspiring developers to receive training from first-rate developers.</p>
                                        <p class="__imppa">Visit page <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></router-link>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">

                                <a href="mailto:admin@findworka.com" target="blank"><div class="__impcard">
                                    <div class="__impimg __sauceimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Saucecode</p>
                                        <p class="__impp1">Our closely knit circle of techies, staying updated on tech trends and following gig alerts.</p>

                                        <p class="__imppa">Join the community <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">

                                <a href="mailto:admin@findworka.com" target="blank"><div class="__impcard">
                                <!-- <a href="#" target="blank"><div class="__impcard"> -->
                                    <div class="__impimg __proimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Findworka PRO</p>
                                        <p class="__impp1">An elite network of pre-vetted designers and developers with competence and real-world experience.</p>

                                        <p class="__imppa">Become a pro <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import navbar1 from "../components/navbar1";
export default {
  components: { navbar1 },

data () {
        return{
            file:'',
        formField: {
            fullname: null,
            email: null,
            phone: null,
            skypeId: null,
            brief: null,
            company: null,
            links: null,
        },
        redirect: true   
        }
    },

    methods: {
        uploadFile(){
            this.file = this.$refs.file.files[0];
          //  var filed = new File();
           // console.log(filed)
        },
        processForm: function() {
            this.$validator.validateAll().then(() => {
                if (! this.errors.any()) {
                    // Make the api call for form submission
                    this.makeFormRequest()
                } else {
                    // Show form validation error toast
                    this.$toasted.global.form_validation_error()
                }
            });
        },
        makeFormRequest: function () {
            let fd = new FormData();
            fd.append('brief_file', this.file) ;
            Object.keys(this.formField).forEach(key => fd.append(key, this.formField[key]));
            axios({
                url:'https://cors-anywhere.herokuapp.com/' +  'http://18.212.187.249/findworka/project/send-brief',
                headers: {"Access-Control-Allow-Origin": "*"},
                method: 'post',
                
                data: fd
                })
                .then((response) => {
                    console.log(response)
                    if (response.data.error == true) {
                        // Should redirect to list if redirect was checked
                        this.$toasted.show(response.data.message[0])
                    }else {
                        this.$toasted.show(response.data.message)
                        // this.$router.push({ name: 'home' })
                    }
                        //Reset form
                })
                .catch(error => this.apiErrorCatcher(error))
                .finally( () => this.resetForm())//clear form automatically after successful request
        },
        resetForm() {
            console.log('Reseting the form')
            var self = this; //you need this because *this* will refer to Object.keys below`

            //Iterate through each object field, key is name of the object field`
            Object.keys(this.formField).forEach(function(key,index) {
            self.formField[key] = '';
            });
            this.file = ''
            this.$refs.file.files[0] = ''
        }
    },


};
</script>

<style scoped>
@import '../assets/css/build';
</style>


// WEBPACK FOOTER //
// src/components/build.vue